// extracted by mini-css-extract-plugin
export default {"PrimarySourceTag":"PrimarySourceTag_PrimarySourceTag__JcUIl"};